var _defs, _polygon, _polygon2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTurkeyFlag({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1500 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ec1c24;}.cls-1,.cls-2{fill-rule:evenodd;}.cls-2{fill:#fff;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "401.34 -1.02 401.34 -2.75 99.32 -2.75 99.32 -1.02 76.11 -1.02 0 -1.02 0 1002.75 1041.06 1002.75 1117.5 1002.75 1423.53 1002.75 1500 1002.75 1500 -1.02 458.8 -1.02 401.34 -1.02"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "1014.58 524.94 960.35 509.43 928.84 556.22 926.83 499.85 872.6 484.34 925.59 465.01 923.58 408.64 958.34 453.06 1011.33 433.73 979.82 480.52 1014.58 524.94"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M863.51,584.21A198.4,198.4,0,0,1,683.85,698.4c-109.58,0-198.43-88.79-198.43-198.37S574.27,301.6,683.85,301.6a198.29,198.29,0,0,1,170.59,97.14c-28.62-30.43-70.5-49.56-117.1-49.56-86.62,0-156.8,66-156.8,147.53s70.18,147.52,156.8,147.52C789.12,644.23,835,620.65,863.51,584.21Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTurkeyFlag);
export default __webpack_public_path__ + "static/media/turkey_flag.da3e3474153c224b4c90c4ca2713a61c.svg";
export { ForwardRef as ReactComponent };